module.exports = __webpack_public_path__ + "img/win.622f99b0.svg";